import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@/shared/i18n';

import { App } from './App';
import './styles/global.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root container is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
